import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useGetVideosQuery } from '../features/video/videoApi'

export default function StudentPortal() {
    const { isSuccess: isSuccessFetchVideos, data: videos } = useGetVideosQuery()
    const [videoId, setVideoId] = useState(null)

    useEffect(() => {
        if (isSuccessFetchVideos) {
            setVideoId(videos[0].id)
        }
    }, [isSuccessFetchVideos, videos])

    return (
        <div className="bg-slate-900 p-4 border border-slate-700/80 rounded-md">
            <h1 className="text-slate-100 font-bold text-xl">Student Portal</h1>
            <div className="space-y-2 mt-4 flex flex-col">
                {videoId && <Link className="link" to={`/course-player/${videoId}`}>Course Player</Link>}
                <Link className="link" to={`/leaderboard`}>Leaderboard</Link>
                <Link className="link" to={`/quiz`}>Quiz</Link>
                <Link className="link" to="/">StudentLogin</Link>
                <Link className="link" to="/student-reistration">StudentReistration</Link>
            </div>
        </div>
    )
}
